<template>
  <sweet-modal ref="categoryModal" width="30%" class="sweet-modal-theme-cheetah sweet-modal-theme-category-create" :title="$t(`ct-category-${category.action}`)" hide-close-button blocking>
    <form action="/" method="POST">
      <div class="form-group">
        <label for="category-name">{{ $t('ct-name') }}</label>
        <input
          type="text"
          class="form-control form-control-simple"
          v-model="category.name"
          name="category-name"
          id="category-name"
          :placeholder="$t('ct-name')"
          minlength="3"
          :class="{ 'is-invalid': errors.has('category.name')}"
          @keyup="errors.clear('category.name')"
          required
        />
        <span
          v-if="errors.has('category.name')"
          class="invalid-feedback"
          v-text="errors.get('category.name')"
        ></span>
      </div>
      <div class="form-group">
        <label for="category-description">{{ $t('ct-description') }}</label>
        <textarea
          id="category-description"
          class="form-control form-control-simple"
          v-model="category.description"
          name="category-description"
          :placeholder="$t('ct-description')"
          minlength="3"
          :class="{ 'is-invalid': errors.has('category.description')}"
          @keyup="errors.clear('category.description')"
        />
        <span
          v-if="errors.has('category.description')"
          class="invalid-feedback"
          v-text="errors.get('category.description')"
        ></span>
      </div>

      <div class="form-group">
        <span>{{ $t('ct-websites') }}</span>
        <div class="row" v-if="websites">
          <span class="col-12 my-2">{{ $t('ct-websites-published') }}</span>

          <div class="col-6" v-for="(website, index) in websites.filter(wb => wb.status === 'active')" :key="index">
            <div class="form-check" >
              <input class="form-check-input" type="checkbox" name="category_websites" v-model="category.websites_list" :id="`website-categories-${website.url}-${index}`" :value="website.id">
              <label class="form-check-label" :for="`website-categories-${website.url}-${index}`">{{ website.title.length > 20 ? website.title.substring(0, 15) + '...' : website.title }}</label>
            </div>
          </div>
        </div>

        <div class="row mt-1" v-if="websites">
          <span class="d-block my-2 col-12">{{ $t('ct-websites-unpublished') }}</span>
          <div class="col-6" v-for="(website, index) in websites.filter(wb => wb.status === 'inactive')" :key="index">
            <div class="form-check" >
              <input class="form-check-input" type="checkbox" name="category_websites" v-model="category.websites_list" :id="`website-categories-${website.url}-${index}`" :value="website.id">
              <label class="form-check-label" :for="`website-categories-${website.url}-${index}`">{{ website.title.length > 20 ? website.title.substring(0, 15) + '...' : website.title }}</label>
            </div>
          </div>
        </div>
      </div>
    </form>

    <button
      slot="button"
      class="btn btn-outline-light"
      @click.prevent="close()"
    >{{ $t('ct-cancel') }}</button>

    <button
      slot="button"
      class="btn btn-success"
      v-if="category.action === 'create'"
      @click.prevent="saveCategory()"
    ><i class="svg-icon svgi-save"></i>{{ $t('ct-save') }}</button>
  </sweet-modal>
</template>

<script>
import {SweetModal} from 'sweet-modal-vue';
import {create as createCategory} from '../../../../js/services/category';
import Errors from '../../../../js/base/Errors';
import {getWebsitesAll} from "../../../../js/services/editor/website";

export default {
  name: 'SiteCategory',
  components: { SweetModal },

  data() {
    return {
      errors: new Errors(),
      websites: [],
      category: {
        name: '',
        description: '',
        action: 'create', // create or update,
        websites_list: []
      }
    };
  },

  watch: {

  },

  methods: {

    fetchWebsiteAll() {
      getWebsitesAll()
        .then(({data}) => {
          this.websites = data;
        })
    },

    open() {
      this.fetchWebsiteAll();
      this.$refs.categoryModal.open();
    },

    async close() {
      await this.$refs.categoryModal.close();
      await setTimeout( () => this.emptyCategory(), 500);
    },

    openNewCategory() {
      this.fetchWebsiteAll();
      this.closeMoveCategory();
      this.$refs.categoryModal.open();
    },

    emptyCategory() {
      this.category = {
        name: '',
        description: '',
        action: 'create',
        websites_list: []
      };
      this.errors.clear();
    },

    saveCategory() {
      if (!this.category.name && !(this.category.name.length > 0)) {
        this.errors.add('name', 'validation-required', 'category');
      }

      if (this.category.name && this.category.name.length > 120) {
        this.errors.add('name', 'field-may-not-be-greater-than-120-char', 'category');
      }

      if (this.category.description && this.category.description.length > 255) {
        this.errors.add('description', 'field-may-not-be-greater-than-255-char', 'category');
      }

      if (!this.errors.any()) {
        this.$loading.show();

        createCategory(this.category)
          .then(async response => {
            this.$emit('newCategory', response.data);
            this.close();
            this.$emit('updateWebsites');
          })
          .catch(error => {
            console.warn(error);
            if (error.response && error.response.data && error.response.data.errors) {
              this.errors.record({ category: error.response.data.errors });
            }
          })
          .finally(() => this.$loading.hide());
      }
    }
  }
};
</script>

<style lang="scss">
.sweet-modal-theme-category-create {
  z-index: 100010;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/layout/site/SiteCategory.vue